import {Action} from 'redux'
import {CardMenuDetailModel} from '../Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialCardMenuDetailState: ICardMenuState = {
  data: {
    cardMenu: [],
    meta: {},
  },
  sortCardMenuDetailData: [],
  cardMenuDetailFileOption: [],
  cardMenuDetailList: {album: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface ICardMenuState {
  data: {
    cardMenu: {[key: string]: number | string}[]
    meta: {[key: string]: number}
  }
  sortCardMenuDetailData?: ICardMenuState[]
  cardMenuDetailFileOption?: []
  cardMenuDetailList?: {album: CardMenuDetailModel[] | any}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ICardMenuState = initialCardMenuDetailState,
  action: ActionWithPayload<ICardMenuState>
) => {
  switch (action.type) {
    //GET CardMenuDetail Data
    case actionTypes.GET_CARD_MENU_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_CARD_MENU_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_CARD_MENU_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET CardMenuDetail File type Data
    case actionTypes.GET_CARD_MENU_FILE_TYPE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_CARD_MENU_FILE_TYPE_SUCCESS: {
      return {
        ...state,
        CardMenuDetailFileOption: action.payload?.cardMenuDetailFileOption,
        loading: false,
      }
    }

    case actionTypes.GET_CARD_MENU_FILE_TYPE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add cardMenuDetail
    case actionTypes.ADD_CARD_MENU_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_CARD_MENU_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_CARD_MENU_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_CARD_MENU_TYPE: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update cardMenuDetail
    case actionTypes.UPDATE_CARD_MENU_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_CARD_MENU_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_CARD_MENU_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_CARD_MENU_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_CARD_MENU_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_CARD_MENU_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_CARD_MENU_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_CARD_MENU_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_CARD_MENU_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_CARD_MENU_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_CARD_MENU_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_CARD_MENU_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_CARD_MENU_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_CARD_MENU_SUCCESS: {
      const changedData: any = action.payload?.data?.cardMenu
      let newData = state?.data?.cardMenu?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state?.data?.meta, album: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_CARD_MENU_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_CARD_MENU_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_CARD_MENU_SUCCESS: {
      const changedData: any = action.payload?.data?.cardMenu
      let newData = state?.data?.cardMenu?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state?.data?.meta, album: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_CARD_MENU_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    //Get cardMenuDetail Reducer
    case actionTypes.GET_ALL_CARD_MENU_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_CARD_MENU_SUCCESS: {
      return {
        ...state,
        data: action.payload?.data,
        cardMenuDetailList: action.payload?.data,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_CARD_MENU_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    // sort
    case actionTypes.SORT_CARD_MENU_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_CARD_MENU_SUCCESS: {
      return {
        ...state,
        sortcardMenuDetailData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_CARD_MENU_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_CARD_MENU_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortcardMenuDetailData: [],
      }
    }
    default:
      return state
  }
}
